/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user'
import { payInfoList, getBranchList } from '@/api/common'
import { getFinanceCommissionById, setFinanceCommissionById, getFinanceOrderMarketCooperationList, getFinanceOrderByMarketCooperationId, setPayeeInfo } from '@/api/financial-center'

import { menuBtn } from '@/utils/menu_level2_button'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {getAgeByCardId} from "@/utils/checkIDCard";
import CommonData from "@/utils/commonData";
import { makeUploadSignature } from "@/utils/uploadMd5"


@Component({
    components:{
        MoreUsersFilter
    }
})
export default class CommissionEdit extends Vue {
    limit = 20
    createdUserRealName = ''
    saveExtraPrice: ''
    studentDialog = false
    studentDialogInputValue = ''
    studentDialogTaleData = []
    studentDialogTotal = 0
    studentDialogPage = 1
    studentDialogTableLoading = false
    orderDialogFilterTotal = 0
    studentDialogSelect = {
        name: '',
        id: '',
        customerId: NaN,
        // marketCooperationCreatedAt: '',
        //     marketCooperationDirectorUserId: '',
        //     marketCooperationId: NaN,
        //     marketCooperationName: '',
        //     marketCooperationTypes: '',
        //     parentMarketCooperationName: ''
    }
    moneyCertificatesArr = []  //打款
    marketCooperationId: ''
    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogSelectTable = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    delOrderIdList = [] // 被本地删除肚饿订单ID数组，

    formData = {
        marketCooperationName: '',
        // isBackStudentContract: '',
        isBackAgentContract: '',
        directorUserId: UserModule.userId || '',
        priceSum: 0,
        directorDepartmentlName: '',
        remark: '',
        deparment: '',
        deparmentId: NaN,
        directorUserName: '',
    }
    tableData = []
    fileList = []
    fileList1 = []

    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'

    orderId: number = null // 如果是从订单列表页点击进来的就会有值，订单id
    backMoneyId: number = null // 编辑的时候会有值，回款id
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 从草稿跳转来的
    backMoneyStatus = ''
    isUpdatedData = '0'
    isShow = ''
    previewVisible = false
    previewPath = ''
    previewName = ''
    newAccountDialog = false //新增收款账户
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    // typeOwnerList = [
    //     {value: 1, label: '个人'},
    //     {value: 2, label: '企业'},
    // ]
    type = '' //账户类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    certificateNo = '' // 身份证号
    phoneNo = '' //手机号
    payInfoLoading = false
    payeeInfoList = [] // 开户名称数据
    payeeInfoId = '' //新建返佣需要
    formRule = {
        name: [{required: true, message: '请选择开户名称', trigger: 'change'}],
        cardNum: [{required: true, message: '请选择银行卡号', trigger: 'change'}],
        phoneNo: [{required: true, message: '请填写手机号', trigger: ['change', 'blur']}],
        certificateNo: [{required: true, message: '请填写身份证号', trigger: ['change', 'blur']}],
        selectedArea: [{ required: true, message: '请填写常住地址信息', trigger: ['change', 'blur'] }],
        selectedDetailArea: [{ required: true, message: '请填写详细地址信息', trigger: ['change', 'blur'] }],
    }
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        price: '',
        page: 1,
        limit: 20,
        id: '',
        status:'',
        selectedArea: [],
        selectedDetailArea: ''
    }
    total: 0
    accountEditBtn = false
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    searchBranchName: any =null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    delArr: any = []
    timer = null
    // isReadonly = false
    syncDialogVisible = false
    msg = ''
    certificateNoDisabled = true
    phoneNoDisabled = true
    financeCommissionAccount = null
    loading = false
    options = CommonData.regionData
    selectedOptions = []
    uploadData = {
        bucket: 'crm',
        signature: ''
    }

    get userName() {
        return UserModule.userName
    }

    // 佣金合计 = 返佣金额 + 额外佣金
    get commission_totals() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.priceSum ? item.priceSum : 0))
        return num
    }
    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.price))
        return num
    }

    get needBackMoney() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.needBackMoney))
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.tableData.forEach(item => {
            if (Number(item.thisBackMoney)) {
                num += Number(item.thisBackMoney)
            }
        })
        return num
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    get moneyCertificatesUrl() {//打款
        return this.moneyCertificatesArr.map(item => item.url)
    }

    created() {
        if (this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
        }

        this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
        this.isShow = this.$route.query.isShow as string
        // 返佣详情
        if (this.$route.query.id) {
            this.backMoneyId = Number(this.$route.query.id)
            this.getFinanceCommissionById()
        }

        if (this.$route.query.draftId) {
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }
        if (this.$route.query.isShow) this.isShow = this.$route.query.isShow as string
        if (this.$route.query.status) this.backMoneyStatus = this.$route.query.status as string
    }
    menuBtn = menuBtn

    getRowKeys(row) {
        return row.id
    }

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }


    // 新建账户
    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList();
    }
    // 开户网点
    async getBranchList() {
        let objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        let result = []
        let obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }
    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }
    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
          this.branchInfoList = []
          this.getBranchList();
        }
    }
    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }
    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }
    handleBranchChange (val) {
        this.branch = val
    }

    doCancel(){
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }

    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
            this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
            return
        }
        let flag = true
        if (this.type === 'PERSONAL') {
            /*身份证号码校验是否符合规则*/
            if (!getAgeByCardId(this.certificateNo)) {
                flag = false
                return
            }
            /*如果是个人账户，正则校验手机号格式是否正确*/
            if (this.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNo))) {
                this.$message.error('请输入正确的手机号');
                flag = false
            }
        }
        if (!flag) {
            return
        }

        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: this.certificateNo,
            phoneNo: this.phoneNo,
        }
        // const data = await setPayeeInfo(obj)
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.payInfo.payeeInfoId = payeeInfoId
        this.$set(this.payInfo, 'name', this.name)
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.$set(this.payInfo, 'phoneNo', this.phoneNo)
        this.$set(this.payInfo, 'certificateNo', this.certificateNo)
        if (!this.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!this.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false

        /*清空旧的数据*/
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []

    }

    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }
    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            if (this.searchCardName && this.payInfo.cardNum) {
                this.searchName = this.payInfo.name
                this.payeeInfoList = []
                this.payInfo.page = 1
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayInfo (query: any) {
        this.searchName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayInfo() {
        this.searchName = null
        this.searchCardName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.certificateNo = 1
        this.payInfo.phoneNo = 1
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        this.payInfoList()
    }
    // 关闭
    closeSyncDialog(){
        this.syncDialogVisible = false
    }

    handlePayInfoChange(item) {
        this.msg = item.message
        if (item.message) {
            this.syncDialogVisible = true
        }
        const indexId = item.id
        let obj = this.payeeInfoList.find((item, index) => item.id === indexId)
        if (obj) {
            this.$set(this.payInfo, 'name', obj.name)
            this.payInfo.cardNum = obj.cardNum
            this.payInfo.branch = obj.branch
            this.payInfo.id = obj.id
            this.payInfo.payeeInfoId = obj.id
            this.payInfo.type = obj.type
            this.$set(this.payInfo, 'phoneNo', obj.phoneNo)
            this.$set(this.payInfo, 'certificateNo', obj.certificateNo)
        }
        if (obj.certificateNo) {
            this.certificateNoDisabled = true
        } else {
            this.certificateNoDisabled = false
        }
        if (obj.phoneNo) {
            this.phoneNoDisabled = true
        } else {
            this.phoneNoDisabled = false
        }
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (indexId == this.financeCommissionAccount.payeeInfoId) {
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.financeCommissionAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.financeCommissionAccount.certificateNo)
            }

            if (this.financeCommissionAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.financeCommissionAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }
    }
    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            if (this.searchName && this.payInfo.name) {
                this.searchCardName = this.payInfo.cardNum
                this.payInfo.page = 1
                this.payeeInfoList = []
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayCard (query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  cardNum: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.searchName = null
        // this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.phoneNo = ''
        this.payInfo.certificateNo = ''
        /*
       * 如果是个人账户清空*/
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''
        this.payInfoList()
    }
    handlePayChangeCard (item) {
        this.msg = item.message
        if(item.message){
            this.syncDialogVisible = true
        }
        const indexId = item.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.$set(this.payInfo, 'name', obj.name)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type
        this.$set(this.payInfo, 'phoneNo', obj.phoneNo)
        this.$set(this.payInfo, 'certificateNo', obj.certificateNo)
        if (!obj.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!obj.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        //    crm 和 易快报不同步 切换的时候要把请求回来的数据赋值
        if (indexId == this.financeCommissionAccount.payeeInfoId) {
            if (!this.payInfo.phoneNo) {
                this.$set(this.payInfo, 'phoneNo', this.financeCommissionAccount.phoneNo)
            }
            if (!this.payInfo.certificateNo) {
                this.$set(this.payInfo, 'certificateNo', this.financeCommissionAccount.certificateNo)
            }
            if (this.financeCommissionAccount.certificateNo) {
                this.certificateNoDisabled = true
            } else {
                this.certificateNoDisabled = false
            }
            if (this.financeCommissionAccount.phoneNo) {
                this.phoneNoDisabled = true
            } else {
                this.phoneNoDisabled = false
            }
        }
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    // 草稿详情页
    async getDraftById() {
        this.loading = true
        await getDraftById(this.draftId).then((data: any)=>{
        const { result } = data
        this.formData.marketCooperationName = result.marketCooperationName
        this.formData.directorUserId = result.directorUserId
        this.formData.directorUserName = result.directorUserRealName
        this.formData.directorDepartmentlName = result.directorDepartmentlName
        this.createdUserRealName = result.createdUserRealName
        // this.formData.isBackStudentContract = result.isBackStudentContract
        this.formData.isBackAgentContract = result.isBackAgentContract
        this.formData.priceSum = Number(result.priceSum)
        this.marketCooperationId = result.marketCooperationId
        this.formData.marketCooperationName = result.marketCooperationName
        this.formData.remark = result.remark  //备注
        this.financeCommissionAccount = result.financeCommissionAccount
        if (!this.financeCommissionAccount.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!this.financeCommissionAccount.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.tableData = result.financeCommissionDetailList.map(item => {
            if (item.extraPrice === "undefined") {
                item.extraPrice = 0
            }
            return {
                customerName: item.customerName,
                companyName: item.companyName,
                code: item.financeOrderCode,
                souCourseName: item.souCourseName,
                souCourseType: item.souCourseType,
                souCourseSchoolBegin: item.souCourseSchoolBegin,
                price: item.financeOrderPrice,
                financeOrderPrice: item.financeOrderPrice,
                commissionRatio: item.financeOrderCommissionRotio,
                priceSum: item.priceSum,
                commissionPrice: item.price,
                extraPrice: item.extraPrice,
                financeOrderId: item.financeOrderId,
                isBackAgentContract: item.isBackAgentContract,
                // isBackStudentContract: item.isBackStudentContract,
            }
        })
        this.fileList1 = result.financeCommissionProofList
        if(result.financeCommissionAccount){
            this.payInfo = result.financeCommissionAccount
            this.accountEditBtn = true
            // 0=>未打款; 1=>打款中; 2=>已打款
            if(result.financeCommissionAccount.status == '0'){
                 this.payInfo.status = '未打款'
            }else if(result.financeCommissionAccount.status == '1'){
                 this.payInfo.status = '打款中'
            }else if(result.financeCommissionAccount.status == '2'){
                 this.payInfo.status = '已打款'
            }else if(result.financeCommissionAccount.status == '3'){
                 this.payInfo.status = '同步失败'
            }
            // this.payInfo = financeCommission.financeCommissionAccount ? financeCommission.financeCommissionAccount : {}
            if(result.financeCommissionAccount.provinces){
                this.$set(this.payInfo,'selectedArea', [result.financeCommissionAccount.provinces, result.financeCommissionAccount.city,result.financeCommissionAccount.districts])
              } else {
                this.$set(this.payInfo,'selectedArea',[])
              }
              this.$set(this.payInfo,'selectedDetailArea',(result.financeCommissionAccount.others?result.financeCommissionAccount.others:''))
            this.getSelectedLabels()
        }
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }
    // 合作伙伴列表
    async getFinanceOrderMarketCooperationList() {
        this.studentDialogTableLoading = true
        const data: any = await getFinanceOrderMarketCooperationList( delNullProperty({
            marketCooperationName: this.studentDialogInputValue,
            page: this.studentDialogPage,
            limit: 20 })
        )
        this.studentDialogTaleData = data.marketCooperationList
        this.studentDialogTotal = data.allNum
        this.studentDialogTableLoading = false
    }

    // 返佣详情
    async getFinanceCommissionById() {
        this.loading = true
        await getFinanceCommissionById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData }).then((data: any)=>{
        const { financeCommission } = data
        this.financeCommissionAccount = financeCommission.financeCommissionAccount
        this.createdUserRealName = financeCommission.createdUserRealName?financeCommission.createdUserRealName:''
        this.formData.marketCooperationName = financeCommission.marketCooperationName
        this.formData.directorUserId = financeCommission.directorUserId
        // this.formData.isBackStudentContract = financeCommission.isBackStudentContract === '是' ? '1' : '0'
        this.formData.isBackAgentContract = financeCommission.isBackAgentContract === '是' ? '1' : '0'
        this.formData.priceSum = Number(financeCommission.priceSum)
        this.marketCooperationId = financeCommission.marketCooperationId
        this.formData.remark = financeCommission.remark  //备注
        this.formData.directorDepartmentlName = financeCommission.directorDepartmentlName  //负责人所属部门
        this.formData.directorUserName = financeCommission.directorUserRealName  //负责人所属部门
        this.tableData = financeCommission.financeCommissionDetailList.map(item => {
            if (item.extraPrice === "undefined") {
                item.extraPrice = 0
            }
            return {
                customerName: item.customerName,
                code: item.financeOrderCode,
                souCourseName: item.souCourseName,
                souCourseType: item.souCourseType,
                souCourseSchoolBegin: item.souCourseSchoolBegin,
                price: item.financeOrderPrice,
                financeOrderPrice: item.financeOrderPrice,
                commissionRatio: item.financeOrderCommissionRotio,
                priceSum: item.priceSum,
                commissionPrice: item.price,
                extraPrice: item.extraPrice,
                // oldThisBackMoney: this.backMoneyStatus === '已通过' ? item.thisTimePrice : 0, // 如果当前回款审批通过，在验证本次回款金额是否正确的时候就需要将本次回款的金额一起验证
                financeOrderId: item.financeOrderId,
                isBackAgentContract: item.isBackAgentContract,
                // isBackStudentContract: item.isBackStudentContract,
                companyName: item.companyName,
            }
        })
        this.orderDialogSelectTable = financeCommission.financeCommissionDetailList
        financeCommission.financeCommissionProofList.map(item => {
            if (item.types == '1') {
                this.fileList1.push({ name: item.name, url: item.url, types: item.types })
            }
            if (item.types == '0') {
                this.moneyCertificatesArr.push({
                    name: item.name,
                    types: item.types,
                    url: item.url,
                })
            }
        })
        if(financeCommission.financeCommissionAccount){
            this.payInfo = financeCommission.financeCommissionAccount
            if (!this.payInfo.certificateNo) {
                this.certificateNoDisabled = false
            } else {
                this.certificateNoDisabled = true
            }
            if (!this.payInfo.phoneNo) {
                this.phoneNoDisabled = false
            } else {
                this.phoneNoDisabled = true
            }
            this.accountEditBtn = true
            // 0=>未打款; 1=>打款中; 2=>已打款
            if(financeCommission.financeCommissionAccount.status == '0'){
                 this.payInfo.status = '未打款'
            }else if(financeCommission.financeCommissionAccount.status == '1'){
                 this.payInfo.status = '打款中'
            }else if(financeCommission.financeCommissionAccount.status == '2'){
                 this.payInfo.status = '已打款'
            }else if(financeCommission.financeCommissionAccount.status == '3'){
                 this.payInfo.status = '同步失败'
            }
            if(financeCommission.financeCommissionAccount.provinces){
                this.$set(this.payInfo,'selectedArea',[financeCommission.financeCommissionAccount.provinces, financeCommission.financeCommissionAccount.city,financeCommission.financeCommissionAccount.districts])
            } else {
                this.$set(this.payInfo,'selectedArea',[])
            }
            this.$set(this.payInfo,'selectedDetailArea',(financeCommission.financeCommissionAccount.others?financeCommission.financeCommissionAccount.others:''))
            this.getSelectedLabels()
        }
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    // async directorUserIdChange(val) {
    //     const selectedItem = this.userList.find(item => item.id === val);
    //     this.formData.deparment = selectedItem.departmentName
    // }

    // 获取订单列表
    async getFinanceOrderByMarketCooperationId() {
        this.orderDialogTableLoading = true

        const obj = {
            mainPart: '1',
            marketCooperationId: this.marketCooperationId,
            customerName: this.orderDialogInputValue,
            page: this.orderDialogPage,
            limit: this.limit
        }
        const data: any = await getFinanceOrderByMarketCooperationId(delNullProperty(obj))
        this.orderDialogTaleData =  data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
        // this.isReadonly = false
        if(this.orderDialogTaleData.length > 0 && this.delArr.length > 0){
            this.orderDialogTaleData.forEach(item => {
                this.delArr.forEach(items=> {
                    if(item.id == items){
                        item.isSelect = true
                    }
                })
            })
        }
        // this.$nextTick(() => {
        //     const dom = this.$refs.orderDialogTable as HTMLFormElement
        //     if (this.tableData.length > 0) {
        //         // dom.clearSelection()
        //         const orderIds = this.tableData.map(item => item.financeOrderId)
        //         const newArr = this.orderDialogTaleData.filter(item => orderIds.includes(item.id))
        //         newArr.forEach(item => {
        //             dom.toggleRowSelection(item, true)
        //             // item.selectDisabled = true
        //         })
        //     } else {
        //         dom.clearSelection()
        //     }
        // })

    }
    //提交
    async clickEditSubmitButton() {
        // '0-否', '1-是'
        let marketCooperationId = this.studentDialogSelect.id
        if (!this.studentDialogSelect.id) {
            marketCooperationId = this.marketCooperationId
        }
        const obj: any = {
            id: this.backMoneyId,   //返佣id
            marketCooperationId: marketCooperationId,   //合作伙伴id
            // isBackStudentContract: this.formData.isBackStudentContract,
            isBackAgentContract: this.formData.isBackAgentContract,
            financeCommissionDetailList: [],
            financeCommissionProofList: [],
            directorUserId: this.formData.directorUserId,//负责人id
            remark: this.formData.remark,//备注
            payeeInfoId: this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : this.payInfo.id ? this.payInfo.id : '', //易快报收款账户id
        }
        obj.financeCommissionDetailList = this.tableData.map(item => ({ financeOrderId: item.financeOrderId, extraPrice: item.extraPrice }))
        if(this.payInfo.type=='个人账户'){
            if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
                obj.provinces = this.payInfo.selectedArea[0]
                obj.city = this.payInfo.selectedArea[1]
                obj.districts = this.payInfo.selectedArea[2]
            }
            obj.others = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:null
            obj.phoneNo = this.payInfo.phoneNo
            obj.certificateNo = this.payInfo.certificateNo
        }
        /** 判断数组的每一项是否都不为空*/
        const isAllZero = obj.financeCommissionDetailList.every(item => (item.extraPrice !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写额外佣金订单，请去填写')
            return;
        }

        obj.financeCommissionProofList = this.fileList1.map(item => ({ url: String(item.url), name: item.name }))
        if (!this.payInfo.name ||  !this.payInfo.cardNum) {
            await this.$message.error('请将收款信息填写完整')
            return
        }

        if(this.saveExtraPrice == '') {
            await this.$message.error('请填写额外佣金'); return
        }
       
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if(valid){
                /*如果是个人账户 身份证号码校验是否符合规则*/
                let flag = true
                if (this.payInfo.type === '个人账户') {
                    if (!getAgeByCardId(this.payInfo.certificateNo)) {
                        flag = false
                        return
                    }
                    /*如果是个人账户，正则校验手机号格式是否正确*/
                    if (this.payInfo.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payInfo.phoneNo))) {
                        this.$message.error('请输入正确的手机号');
                        flag = false
                    }
                }
                if (!flag) {
                    return;
                }
                // if (this.payInfo.type === '个人账户' && (this.payInfo.selectedArea.length < 1 || !this.payInfo.selectedDetailArea)) {
                //     this.$message.error('请输入常住地址信息！')
                //     return;
                // }
                this.disabledButton = true
                this.loading = true
                setFinanceCommissionById(obj).then(res => {
                    this.$message.success('提交成功，页面即将关闭')
                    this.loading = false
                    setTimeout(() => {
                        window.close()
                    }, 1500)
                }).catch(err => {
                    if (err.message === '审批流报错') {
                        this.errorDialogShow = true
                    }
                    this.disabledButton = false
                    this.loading=  false
                })
            }
        })

    }
    // 选择合作伙伴
    chooseParnter(e) {
        this.studentDialog = true
        this.getFinanceOrderMarketCooperationList()
        e.target.blur()
    }
    // 合作伙伴确定事件
    parnterDialogConfirm() {
        // this.formData.parnterName = this.parnterDialogSelect.marketCooperationName
        this.studentDialog = false
        this.studentDialogInputValue = ''
        this.tableData = []
    }
    studentDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const studentTable = this.$refs.studentDialogTable as HTMLFormElement
                studentTable.clearSelection()
                studentTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.studentDialogSelect) {
                this.studentDialogSelect[key] = null
            }
        }
    }
    studentDialogPageChange(page: number) {
        this.studentDialogPage = page
        this.getFinanceOrderMarketCooperationList()
    }
    // 添加订单
    clickAddOrder() {
        if (!this.formData.marketCooperationName) {
            this.$message.error('请选择合作伙伴')
            return
        }
        this.orderDialog = true
        this.orderDialogPage = 1
        this.orderDialogInputValue = ''
        this.getFinanceOrderByMarketCooperationId()
        this.defaultChecked()
    }
    defaultChecked(){
        this.$nextTick(() => {
            let order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableData.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }
    // 订单列表确认
    orderDialogConfirm() {
        if (this.orderDialogSelectTable.length > 0) {
            // 将 this.tableData 中没有但是 this.orderDialogSelectTable 中有的数据，添加到 this.tableData 中
            const orderIds = this.tableData.map(item => item.financeOrderId)
            this.orderDialogSelectTable.forEach(item => {
                if(orderIds.includes(item.id) === false) {
                    this.tableData.push({
                        ...item,
                        priceSum: item.commissionPrice,
                        extraPrice: '0',
                        financeOrderId: item.id,
                        thisBackMoney: 0,
                        oldThisBackMoney: 0 // 新建的时候默认 oldThisBackMoney = 0，当编辑审批通过的回款的时候，需要用来记录编前的当前回款
                    })
                }
            })
            // 将 this.orderDialogSelectTable 中没有但是 this.tableData 中有的数据删除
            const orderIds1 = this.orderDialogSelectTable.map(item => item.financeOrderId ? item.financeOrderId : item.id)
            this.tableData = this.tableData.filter(item => orderIds1.includes(item.financeOrderId))
        } else {
            this.tableData = []
        }
        this.orderDialog = false
        this.orderDialogInputValue = ''
    }

// 选项发生变化时触发
    handleSelectionChange(selectionArr: any[]) {
        // val代表整个表格选中的行数据
        this.orderDialogSelectTable = selectionArr
        // if(this.tableData.length > 0){
        //     this.tableData.map(item => {
        //         this.orderDialogSelectTable.map(items => {
        //             if(item.financeOrderId == items.financeOrderId) {
        //                 items.priceOrScore = item.priceOrScore
        //             }
        //         })
        //     })
        // }
    }


    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
        this.getFinanceOrderByMarketCooperationId()
    }
    handleSizeChange(val) {
        this.limit = val
        this.getFinanceOrderByMarketCooperationId()
    }

    clickDelOrder(row) {
        let id = row.financeOrderId ? row.financeOrderId : row.id
        if(this.delArr.length > 0){
            this.delArr.forEach(e => {
                if(e != id){
                    this.delArr.push(id)
                }
            })
        }else {
            this.delArr.push(id)
        }
        // this.tableData = this.tableData.filter(item => item.financeOrderId !== row.financeOrderId)
        this.tableData = this.tableData.filter(item => (item.financeOrderId ? item.financeOrderId : item.id ) !== (row.financeOrderId ? row.financeOrderId : row.id))
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => (item.financeOrderId ? item.financeOrderId : item.id ) !== (row.financeOrderId ? row.financeOrderId : row.id))
        this.tableData.forEach(item => {
            if (this.$refs.orderDialogTable)
                (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(item, true)
        })
    }

    thisBackMoneyChange(row, val: string) {
        // 佣金总计 = 返佣金额 + 额外佣金
        row.priceSum = Math.round((Number(row.commissionPrice) + Number(val)) * 100) / 100
        this.saveExtraPrice = row.extraPrice
    }


    async clickStudentDialogFilter() {
        this.studentDialogPage = 1
        this.studentDialogTableLoading = true
        const data: any = await getFinanceOrderMarketCooperationList({ marketCooperationName: this.studentDialogInputValue, page: this.studentDialogPage, limit: this.studentDialogTotal })
        this.studentDialogTaleData = data.marketCooperationList.filter(item => item.name.includes(this.studentDialogInputValue))
        this.studentDialogTableLoading = false
    }
    studentDialogConfirm() {
        this.formData.marketCooperationName = this.studentDialogSelect.name
        this.studentDialog = false
        this.studentDialogInputValue = ''
        this.tableData = []
    }

    clickOrderDialogFilter(val) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogInputValue = val
            this.getFinanceOrderByMarketCooperationId()
        }, 1000)
    }
    // 草稿  保存-提交
    setDraftById(isSubmit: string) {
        // let isBackStudentContract = "";
        let isBackAgentContract = "";
        // if (this.formData.isBackStudentContract == '是' || this.formData.isBackStudentContract == '1') {
        //     isBackStudentContract = '1'
        // } else if (this.formData.isBackStudentContract == '否' || this.formData.isBackStudentContract == '0') {
        //     isBackStudentContract = '0'
        // }
        if (this.formData.isBackAgentContract == '是' || this.formData.isBackAgentContract == '1') {
            isBackAgentContract = '1'
        } else if (this.formData.isBackAgentContract == '否' || this.formData.isBackAgentContract == '0') {
            isBackAgentContract = '0'
        }
        let flag = true
        if (this.payInfo.type == '个人账户') {
            /*身份证号码校验是否符合规则*/
            if (!getAgeByCardId(this.payInfo.certificateNo)) {
                flag = false
                return
            }
            /*如果是个人账户，正则校验手机号格式是否正确*/
            if (this.payInfo.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payInfo.phoneNo))) {
                this.$message.error('请输入正确的手机号');
                flag = false
            }
        }
        if (!flag) {
            return;
        }


        const obj: any = {
            id: this.backMoneyId,   //返佣id
            marketCooperationId: this.studentDialogSelect.id,   //合作伙伴id
            // isBackStudentContract: isBackStudentContract,  //是否交回学生合同 允许值: '0-否', '1-是'
            isBackAgentContract: isBackAgentContract,  //是否交回代理合同 允许值: '0-否', '1-是'
            financeCommissionDetailList: [],
            directorUserId: this.formData.directorUserId,//负责人id
            financeCommissionProofList: this.fileList1,
            remark: this.formData.remark,//备注
            payeeInfoId: this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : this.payInfo.id ? this.payInfo.id : '', //易快报收款账户id
        }

        obj.financeCommissionDetailList = this.tableData.map(item => ({ financeOrderId: item.financeOrderId, extraPrice: item.extraPrice }))

        if (this.payInfo.type == '个人账户') {
            if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
                obj.provinces = this.payInfo.selectedArea[0]
                obj.city = this.payInfo.selectedArea[1]
                obj.districts = this.payInfo.selectedArea[2]
            }
            obj.others = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:null
            obj.certificateNo = this.payInfo.certificateNo
            obj.phoneNo = this.payInfo.phoneNo
        }

        if (this.payInfo.id == '') {
            this.$message.error('请将收款账户信息填写完整')
            return
        }
        this.disabledButton = true
        this.loading = true
        setDraftById({
            id: this.draftId,
            form: obj,
            isSubmit
        }).then(res => {
            this.$message.success(`${isSubmit === '0' ? '保存成功，页面即将关闭' : '提交成功，页面即将关闭'}`)
            this.loading = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if (err.message == '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
            this.loading=  false
        })
    }
    handleStudentRowClick(row) {
        (this.$refs.studentDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    handleOrderRowClick(row) {
        if (this.orderDialogTaleData.some(item => item.id != row.id) && row.isSelect == true) {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }
    orderDialogTableSelect(row) {
        //row.isSelect == true  可勾选
        return row.isSelect
    }


    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    uploadSuccess1(response, file, fileList) {
        if (fileList.every(item => item.status == 'success')) {
            this.fileList1 = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }
    uploadError1() {
        this.$message.error('上传失败')
    }
    handleUploadRemove1(file) {
        this.fileList1 = this.fileList1.filter(item => item.uid !== file.uid)
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }
    // 点击存草稿
    clickSavaDraftButton() {
        this.isDraft = '1'
        this.saveDraftDialogShow = true
    }
    // 存草稿确认事件
    saveDraftDialogConfirm() {
        // this.clickSubmintButton()
    }
    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    closePage() {
        window.close()
    }

    changeDirectorUserId(e){
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.directorDepartmentlName = e.departmentName
        }
    }
    handleChange(value) {
        // 如果需要获取中文名称，可以通过以下方式
        const province = this.findLabelByValue(this.options, value[0])
        const city = this.findLabelByValue(province.children, value[1])
        const district = this.findLabelByValue(city.children, value[2])
        // this.payInfo.selectedArea = [province.label,city.label,district.label]
        this.$set(this.payInfo, 'selectedArea',[province.label,city.label,district.label])
      }

    getSelectedLabels() {
        if (this.payInfo.selectedArea.length !== 3) return []
        const province = this.options.find(item => item.label === this.payInfo.selectedArea[0])
        // 兼容小程序地址
        let city = null
        city = province.children.find(item => item.label.includes(this.payInfo.selectedArea[1]))
        let district
        if (city.children)
            district = city.children.find(item => item.label.includes(this.payInfo.selectedArea[2]))
        //   如果没有第三级 则回显前两级别，并补充第三级为'—'
        if (!district) {
            this.payInfo.selectedArea = [province.label, city.label, '—']
            district = {label: '—', value: city.value + '00'}
        }
        this.selectedOptions = [province.value, city.value, district.value]
    }
      // 根据value查找对应的label
      findLabelByValue(arr, value) {
        return arr.find(item => item.value === value)
      }

    // @Watch("directorUserId", { deep: true })
    // handle(userId: string) {
    //     this.formData.directorUserId = userId
    //     if (userId !== '1') {
    //         this.directorUserIdChange()
    //     }
    // }

}
